import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import Box from './primitives/Box';
import { StyledSystemProps } from '../../theme/StyledSystemProps';
import { SCREEN } from '../../theme/breakpoints';

const isMobile = SCREEN.isMobile;
const isTablet = SCREEN.isTablet;
const isWeb = SCREEN.isWeb;

type CardProps = StyledSystemProps & {
  color?: string;
  boxSizing?: string;
  maxHeight?: string;
  minHeight?: string;
  onClick?: () => void;
  children: ReactNode;
};

const StyledBox = styled(Box as any)<CardProps>`
  box-shadow: var(--ib-shadow-md);
  display: ${!isWeb && 'flex'};
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  fontsize: ${isMobile && !isWeb && '13px'};
  fontsize: ${isTablet && !isWeb && '18px'};
  margin-top: ${!isWeb && '15px'};
  padding: ${isMobile && !isWeb && '8px'};
  padding: ${isTablet && !isWeb && '8px'};
  @media screen and (max-width: 1024px) {
    ${props => (props.maxHeight ? `max-height: ${props.maxHeight}` : '')};
    min-width: 300px;
    max-width: 100%;
    border-radius: 10px;
  }
`;

const Card: FC<CardProps> = props => (
  <StyledBox onClick={props.onClick} {...props}>
    {props.children}
  </StyledBox>
);

Card.defaultProps = {
  bg: '#FFF',
  borderRadius: isWeb ? '8px' : '0',
  boxShadow: '0 4px 12px rgba(16, 24, 40, 0.08), 0 1px 3px rgba(16, 24, 40, 0.06)',
  boxSizing: 'border-box',
  onClick: () => null,
  p: '15px',
};

export default Card;
